module.exports = {
  i18n: {
      locales: ['en', 'zh', 'cn', 'hk'],
      defaultLocale: 'en',
  },
}